var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.existingMortgagesIsVisible
    ? _c(
        "div",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "section-title",
                    {
                      attrs: { "title-type": "subtitle" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "actions",
                            fn: function () {
                              return [
                                _c("delete-element-icon", {
                                  on: {
                                    delete: function ($event) {
                                      return _vm.handleDeleteExistingMortgage()
                                    },
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1512989275
                      ),
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("formatNumeral")(
                              _vm.existingMortgageIndex + 1,
                              "0o"
                            )
                          ) +
                          " Mortgage\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.propertyExistingMortgageMortgageTypeVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgageMortgageType,
                          validator: _vm.getValidator(
                            "existingMortgageMortgageType"
                          ),
                          options: _vm.mortgageTypeOptions,
                          label: _vm.$t(
                            "application-standalone.questions.mortgageType"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.mortgageType"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageMortgageType = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.propertyExistingMortgageBalanceRemainingVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          value: _vm.existingMortgageBalanceRemaining,
                          validator: _vm.getValidator(
                            "existingMortgageBalanceRemaining"
                          ),
                          label: _vm.$t(
                            "application-standalone.questions.balanceRemaining"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.balanceRemaining"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageBalanceRemaining = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.propertyExistingMortgagePaymentAmountVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          value: _vm.existingMortgagePaymentAmount,
                          validator: _vm.getValidator(
                            "existingMortgagePaymentAmount"
                          ),
                          label: _vm.$t(
                            "application-standalone.questions.paymentAmount"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.paymentAmount"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgagePaymentAmount = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.propertyExistingMortgageFrequencyVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgageFrequency,
                          validator: _vm.getValidator(
                            "existingMortgageFrequency"
                          ),
                          options: _vm.mortgageFrequencyOptions,
                          label: _vm.$t(
                            "application-standalone.questions.frequency"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.frequency"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageFrequency = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.propertyExistingMortgageMaturityDateVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("date-field", {
                        attrs: {
                          value: _vm.existingMortgageMaturityDate,
                          validator: _vm.getValidator(
                            "existingMortgageMaturityDate"
                          ),
                          label: _vm.$t(
                            "application-standalone.questions.maturityDate"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.maturityDate"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageMaturityDate = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.propertyExistingMortgageRateTypeVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgageRateType,
                          validator: _vm.getValidator(
                            "existingMortgageRateType"
                          ),
                          options: _vm.mortgageRateTypeOptions,
                          label: _vm.$t(
                            "application-standalone.questions.rateType"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.rateType"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageRateType = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.propertyExistingMortgageTermTypeVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgageTermType,
                          validator: _vm.getValidator(
                            "existingMortgageTermType"
                          ),
                          options: _vm.mortgageTermTypeOptions,
                          label: _vm.$t(
                            "application-standalone.questions.termType"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.termType"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageTermType = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.propertyExistingMortgageLenderVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("text-field", {
                        attrs: {
                          value: _vm.existingMortgageLender,
                          validator: _vm.getValidator("existingMortgageLender"),
                          label: _vm.$t(
                            "application-standalone.questions.lender"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.lender"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageLender = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.propertyExistingMortgagePayoffVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgagePayoff,
                          validator: _vm.getValidator("existingMortgagePayoff"),
                          options: _vm.mortgagePayoffOptions,
                          label: _vm.$t(
                            "application-standalone.questions.payoff"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.payoff"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgagePayoff = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.propertyExistingMortgageLoanTypeVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value: _vm.existingMortgageLoanType,
                          validator: _vm.getValidator(
                            "existingMortgageLoanType"
                          ),
                          options: _vm.mortgageLoanTypeOptions,
                          label: _vm.$t(
                            "application-standalone.questions.loanType"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.loanType"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageLoanType = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.propertyExistingMortgageInterestRateVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("percentage-field", {
                        attrs: {
                          value: _vm.existingMortgageInterestRate,
                          validator: _vm.getValidator(
                            "existingMortgageInterestRate"
                          ),
                          label: _vm.$t(
                            "application-standalone.questions.interestRate"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.interestRate"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageInterestRate = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.propertyExistingMortgageCurrentMortgageNumberVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("text-field", {
                        attrs: {
                          value: _vm.existingMortgageCurrentMortgageNumber,
                          validator: _vm.getValidator(
                            "existingMortgageCurrentMortgageNumber"
                          ),
                          label: _vm.$t("application-form.mortgage-number"),
                          placeholder: _vm.$t(
                            "application-form.mortgage-number"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageCurrentMortgageNumber = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.propertyExistingMortgageOrigAmountVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("currency-field", {
                        attrs: {
                          value: _vm.existingMortgageOrigAmount,
                          validator: _vm.getValidator(
                            "existingMortgageOrigAmount"
                          ),
                          label: _vm.$t(
                            "application-standalone.questions.origAmount"
                          ),
                          placeholder: _vm.$t(
                            "application-standalone.questions.origAmount"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageOrigAmount = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.propertyExistingMortgageBlendedAmortizationVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("checkbox-field", {
                        attrs: {
                          value: _vm.existingMortgageBlendedAmortization,
                          validator: _vm.getValidator(
                            "existingMortgageBlendedAmortization"
                          ),
                          "option-label": _vm.$t(
                            "application-form.blended-amortization"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageBlendedAmortization = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.propertyExistingMortgageInsuredVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("checkbox-field", {
                        attrs: {
                          value: _vm.existingMortgageInsured,
                          validator: _vm.getValidator(
                            "existingMortgageInsured"
                          ),
                          "option-label": _vm.$t("application-form.insured"),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageInsured = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _vm.propertyExistingMortgageMortgageInsuranceProviderIdVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("select-field", {
                        attrs: {
                          value:
                            _vm.existingMortgageMortgageInsuranceProviderId,
                          validator: _vm.getValidator(
                            "existingMortgageMortgageInsuranceProviderId"
                          ),
                          options: _vm.mortgageInsuranceProviderOptions,
                          label: _vm.$t(
                            "application-standalone.questions.subjectProperty.insurer"
                          ),
                          placeholder: _vm.$t("application-form.insurer"),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageMortgageInsuranceProviderId =
                              $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.propertyExistingMortgageInsuranceAccountNumberVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("text-field", {
                        attrs: {
                          value: _vm.existingMortgageInsuranceAccountNumber,
                          validator: _vm.getValidator(
                            "existingMortgageInsuranceAccountNumber"
                          ),
                          label: _vm.$t(
                            "application-standalone.questions.subjectProperty.insuranceAccountNumber"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageInsuranceAccountNumber = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.propertyExistingMortgageRefiAdditionalInfoVisible
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("text-field", {
                        attrs: {
                          value: _vm.existingMortgageRefiAdditionalInfo,
                          validator: _vm.getValidator(
                            "existingMortgageRefiAdditionalInfo"
                          ),
                          label: _vm.$t(
                            "application-form.additional-information"
                          ),
                          "show-required-indicator": "",
                        },
                        on: {
                          "update:value": function ($event) {
                            _vm.existingMortgageRefiAdditionalInfo = $event
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }